import {
  DefaultEffects,
  IconButton,
  Label,
  Panel,
  PanelType,
} from "@fluentui/react";
import { useCallback, useEffect, useState } from "react";
import { PanelHeader } from "../../../components/Panel/PanelHeader";
import { useEditarPlantiallaVerificacionDetalle } from "../../../hooks/CheckList/useEditarPlantiallaVerificacionDetalle";
import { IPlantillaVerificacion } from "../../../Interfaces/IPlantillaVerificacion";
import {
  IGrupoVerificacion,
  IPostEditarPlantillaVerificacion,
} from "../../../Interfaces/ListaVerificacion/PlantillaVerificacionDetalle/IPlantillaVerificacionDetalle";
import { PanelFooter } from "../../../components/Panel/PanelFooter";

interface IPanelEditarPlantillaCheckList {
  isOpen: boolean;
  onDismiss: () => void;
  plantilla: IPlantillaVerificacion | undefined;
}
export const PanelEditarPlantillaCheckList = (
  props: IPanelEditarPlantillaCheckList
) => {
  const {
    responseDataDetalle,
    PostEditarPlantillaVerificacionDetalle,
    loading,
    response,
  } = useEditarPlantiallaVerificacionDetalle(
    props.isOpen,
    props.plantilla?.plantillaListaVerificacionId
  );

  const [gruposVerificaciones, setGruposVerificaciones] = useState<
    IGrupoVerificacion[]
  >([]);
  const [requestPlantilla, setRequestPlantilla] =
    useState<IPostEditarPlantillaVerificacion>(null!);

  useEffect(() => {
    if (responseDataDetalle) {
      setGruposVerificaciones(responseDataDetalle.propiedadesVerificaciones);
    }
  }, [responseDataDetalle]);

  useEffect(() => {
    setRequestPlantilla({
      plantillaVerificacionId: props.plantilla?.plantillaListaVerificacionId,
      detallePlantillaVerificacion: gruposVerificaciones,
    });
  }, [gruposVerificaciones]);

  const onRenderHeader = useCallback(
    () => (
      <>
        <PanelHeader
          nameIconHeader="Add"
          subTextHeader={`Editar plantilla`}
          textHeader={`Editar de Plantilla de  CheckList  ${responseDataDetalle?.nombrePlantilla}`}
        />
      </>
    ),
    [responseDataDetalle]
  );

  const handleMoveUp = (detalle, grupo) => {
    const updatedGrupos = gruposVerificaciones.map((item) => {
      if (item.orderDeGrupo === grupo) {
        const index = item.detalle.findIndex((d) => d === detalle);
        if (index > 0) {
          const tempOrden = item.detalle[index].orden;
          item.detalle[index].orden = item.detalle[index - 1].orden;
          item.detalle[index - 1].orden = tempOrden;
          const temp = item.detalle[index];
          item.detalle[index] = item.detalle[index - 1];
          item.detalle[index - 1] = temp;
        }
      }
      return item;
    });
    console.log("Ees es arriba", updatedGrupos);

    setGruposVerificaciones(updatedGrupos);
  };

  const handleMoveDown = (detalle, grupo) => {
    const updatedGrupos = gruposVerificaciones.map((item) => {
      if (item.orderDeGrupo === grupo) {
        const index = item.detalle.findIndex((d) => d === detalle);
        if (index < item.detalle.length - 1) {
          const tempOrden = item.detalle[index].orden;
          item.detalle[index].orden = item.detalle[index + 1].orden;
          item.detalle[index + 1].orden = tempOrden;
          const temp = item.detalle[index];
          item.detalle[index] = item.detalle[index + 1];
          item.detalle[index + 1] = temp;
        }
      }
      return item;
    });
    console.log("Ees es abajo", updatedGrupos);
    setGruposVerificaciones(updatedGrupos);
  };
  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Editar"
          texto2="Salir"
          onClick={() => {
            PostEditarPlantillaVerificacionDetalle(requestPlantilla);
          }}
          onDismiss={() => {
            props.onDismiss();
          }}
        />
      </>
    ),
    [PostEditarPlantillaVerificacionDetalle, requestPlantilla]
  );

  return (
    <Panel
      type={PanelType.largeFixed}
      isOpen={props.isOpen}
      onDismiss={props.onDismiss}
      isFooterAtBottom
      onRenderHeader={onRenderHeader}
      onRenderFooter={onRenderFooter}
    >
      <>
        <div className="ms-Grid" dir="ltr">
          {gruposVerificaciones.map((items) => (
            <>
              <div
                id="Cabecerra"
                className="ms-Grid-row"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  height: "auto",
                  backgroundColor: "#979593",
                  boxShadow: DefaultEffects.elevation64,
                }}
              >
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg9">
                  <Label
                    styles={{
                      root: {
                        color: "White",
                        fontSize: "14px",
                        padding: "5px",
                        fontFamily: "Monaco, Menlo, Consolas",
                      },
                    }}
                  >
                    {items.nombreGrupo}
                  </Label>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg2">
                  <Label
                    styles={{
                      root: {
                        color: "White",
                        fontSize: "16px",
                        fontFamily: "Monaco, Menlo, Consolas",
                      },
                    }}
                  >
                    {items.orderDeGrupo}
                  </Label>
                </div>
              </div>
              {items.detalle.map((detalle, i) => (
                <>
                  <div
                    id="registros"
                    className="ms-Grid-row"
                    style={{
                      display: "flex-container",
                      border: "0.5px solid #b3b0ad",
                      flexDirection: "row",
                      backgroundColor: "#faf9f8",
                      height: "auto",
                      alignItems: "end",
                      order: detalle.orden,
                    }}
                  >
                    <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg9">
                      <Label  style={{fontSize:"12px"}}> {detalle.nombre}</Label>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg2">
                      <Label  style={{fontSize:"11px"}}> {detalle.orden}</Label>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg1">
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <IconButton
                          iconProps={{
                            iconName: "ChevronDown",
                            color: "while",
                          }}
                          title="Abajo"
                          ariaLabel="abajo"
                          onClick={() => {
                            handleMoveDown(detalle, items.orderDeGrupo);
                          }}
                        />
                        <IconButton
                          iconProps={{ iconName: "ChevronUp", color: "while" }}
                          title="Arriba"
                          ariaLabel="arriba"
                          onClick={() => {
                            handleMoveUp(detalle, items.orderDeGrupo);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              ))}
            </>
          ))}
        </div>
      </>
    </Panel>
  );
};
